"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailDetailsActions = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function EmailDetailsActions(_a) {
    var handleEmailDownload = _a.handleEmailDownload, handleOpenInGmail = _a.handleOpenInGmail;
    return (react_1.default.createElement(core_ui_1.Flexbox, { justifyContent: "flex-end", alignItems: "center" },
        react_1.default.createElement(core_ui_1.Button, { onClick: handleEmailDownload, target: "_blank" }, "Download email"),
        react_1.default.createElement(core_ui_1.Spacing, { width: 8 }),
        react_1.default.createElement(core_ui_1.Button, { href: handleOpenInGmail(), target: "_blank" }, "Open in Gmail")));
}
exports.EmailDetailsActions = EmailDetailsActions;
